var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.25a.25.25 0 0 0-.25.25v2.532a.25.25 0 0 0 .09.192l6.64 5.533a.75.75 0 0 1 .27.576v5.953l2.362-1.18a.25.25 0 0 0 .138-.224v-4.549a.75.75 0 0 1 .27-.576l6.64-5.533a.25.25 0 0 0 .09-.192V4.5a.25.25 0 0 0-.25-.25H4Zm-1.75.25c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v2.532a1.75 1.75 0 0 1-.63 1.344l-6.37 5.308v4.198c0 .663-.374 1.269-.968 1.565l-2.724 1.362A1.25 1.25 0 0 1 9.25 19.69v-6.007L2.88 8.376a1.75 1.75 0 0 1-.63-1.344V4.5Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37 7.5a.75.75 0 0 1 .75-.75h17.76a.75.75 0 0 1 0 1.5H3.12a.75.75 0 0 1-.75-.75Z",
    fill: "#374151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d6c8f80d.svg";
export { ForwardRef as ReactComponent };